export default __webpack_public_path__ + "static/media/IMG5009.8b49957f.jpg";